import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const portalUrl = process.env.REACT_APP_PORTAL_URL;

  return (
    <div
      data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1e3"
      data-animation="default"
      data-collapse="medium"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className="navbar w-nav"
    >
      <div className="nav-container _1430">
        <div className="navbar-container">
          <a href="index.html" className="navbar-logo w-nav-brand">
            <img
              src="/images/noa-logo.png"
              loading="lazy"
              alt=""
              className="navbar-logo-image"
            />
          </a>
          <nav role="navigation" className="nav-menu w-nav-menu">
            <Link to="/" className="nav-menu-link w-nav-link">
              {t("home")}
            </Link>
            <a
              href={portalUrl}
              className="nav-menu-link w-nav-link"
            >
              {t("Portal")}
            </a>
            {/* <Link
              to='/about'
              className="nav-menu-link w-nav-link"
            >
              {t("about")}
            </Link>
            <Link to='/pricing' className="nav-menu-link w-nav-link">{t("pricing")}</Link>
            <Link to='/technology' className="nav-menu-link w-nav-link">{t("Technology")}</Link> */}
          </nav>
          <div className="navbar-button-wrapper">
            <div className="primary-button-wrapper desktop">
              <a
                href="/JoinNow"
                data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                className="primary-button w-inline-block"
              >
                <div className="primary-button-border-wrap">
                  <div className="primary-button-wrap">
                    <div className="primary-button-text">Get started</div>
                    <div className="primary-button-hover-text">Get started</div>
                    <div className="primary-button-hover-bg"></div>
                  </div>
                </div>
                <div className="line-wrap">
                  <div className="primary-line-wrap _1">
                    <div className="line _1"></div>
                    <div className="line _2"></div>
                  </div>
                  <div className="primary-line-wrap _2">
                    <div className="line _3"></div>
                    <div className="line _4"></div>
                  </div>
                  <div className="primary-line-wrap _3">
                    <div className="line _5"></div>
                    <div className="line _6"></div>
                  </div>
                  <div className="primary-line-wrap _4">
                    <div className="line _7"></div>
                    <div className="line _8"></div>
                  </div>
                </div>
              </a>
            </div>
            <div className="menu-button w-nav-button">
              <div
                data-is-ix2-target="1"
                className="hamburger-menu-icon"
                data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                data-animation-type="lottie"
                data-src="/images/hamburger-20menu.lottie"
                data-loop="0"
                data-direction="1"
                data-autoplay="0"
                data-renderer="svg"
                data-duration="0"
                data-ix2-initial-state="0"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
